import './constants.credit-card';
import './services.sl-payment';
import './services.logger';
import loggerService from '../../utils/loggerService';

app.directive('checkoutShoplinePaymentV2', [
  'slPaymentService',
  'cart',
  '$rootScope',
  'slFeatureService',
  'creditCard',
  function (slPaymentService, cart, $rootScope, slFeatureService, creditCard) {
    return {
      restrict: 'A',
      scope: {
        onSdkInit: '&',
        useShoplinePaymentQuickPayment: '=?',
      },
      link: function (scope) {
        try {
          const isSubscriptionOrder = cart.items?.some(
            (item) => item.type === 'subscription_product',
          );

          const paymentConfig = {
            ...slPaymentService.getDefaultPaymentConfig(cart.payment_method),
            amount:
              cart.total.currency_iso === 'TWD'
                ? cart.total.cents * 100
                : cart.total.cents,
            customerToken: '',
            paymentInstrument: {
              bindCard: {
                enable: false,
                protocol: {
                  mustAccept: false,
                  textType: {
                    paymentAgreement: false,
                  },
                  defaultSwitchStatus: false,
                  switchVisible: false,
                },
              },
            },
          };

          const renderSDK = (paymentConfig) => {
            slPaymentService
              .renderSDK({
                paymentConfig,
                elementId: '#checkout-shopline-payment-v2-form',
              })
              .then((data) => {
                scope.onSdkInit({ value: data });
              })
              .catch((error) => {
                loggerService.error(new Error('renderSDKError'), {
                  context: { error },
                });
              });
          };

          if (
            !slFeatureService.hasFeature('slp_remember_credit_card') ||
            cart.payment_method.config_data.shopline_payment_payment !==
              'credit' ||
            cart.payment_method.config_data?.installments.length > 0
          ) {
            renderSDK(paymentConfig);
            return;
          }

          const initBeforeRenderSDK = async () => {
            if ($rootScope.currentUser) {
              const paymentInstrumentsRes =
                await slPaymentService.getPaymentInstruments();
              const tokenRes = await slPaymentService.getCustomerToken();
              const cardList = paymentInstrumentsRes.data;
              if (tokenRes?.data?.customer_token) {
                paymentConfig.customerToken = tokenRes.data.customer_token;
                paymentConfig.paymentInstrument.bindCard.enable = true;
                scope.useShoplinePaymentQuickPayment = false;
              }

              if (cardList.length < creditCard.CARD_LIST_LIMIT) {
                paymentConfig.paymentInstrument.bindCard.protocol.textType.paymentAgreement = true;
                paymentConfig.paymentInstrument.bindCard.protocol.switchVisible = true;
                scope.useShoplinePaymentQuickPayment = true;
              }

              if (cardList.length === creditCard.CARD_LIST_LIMIT) {
                scope.useShoplinePaymentQuickPayment = true;
              }

              if (isSubscriptionOrder) {
                paymentConfig.paymentInstrument = {
                  bindCard: {
                    enable: true,
                    protocol: {
                      mustAccept: true,
                      textType: {
                        paymentAgreement: true,
                        subscribeAgreement: true,
                      },
                      defaultSwitchStatus: false,
                      switchVisible: true,
                    },
                  },
                };
              }

              renderSDK(paymentConfig);
            } else {
              if (isSubscriptionOrder) {
                paymentConfig.paymentInstrument = {
                  bindCard: {
                    enable: true,
                    protocol: {
                      mustAccept: true,
                      textType: {
                        paymentAgreement: false,
                        subscribeAgreement: true,
                      },
                      defaultSwitchStatus: true,
                      switchVisible: false,
                    },
                  },
                };
              }

              renderSDK(paymentConfig);
            }
          };

          initBeforeRenderSDK();
        } catch (e) {
          loggerService.error(e);
        }
      },
    };
  },
]);
